import { defineStore } from 'pinia';
import { getSiteFeaturesRequest } from '../services/apiServices';

const FEATURE_CACHE_TTL_MS = 60 * 1000;
let featureRequest = null;

export const useSiteFeatures = defineStore('siteFeatures', {
    state: () => ({
        loaded: false,
        loading: false,
        lastLoadedAt: 0,
        newsEnabled: false
    }),
    actions: {
        isEnabled(featureKey = '') {
            return `${featureKey || ''}`.trim().toLowerCase() === 'news'
                ? this.newsEnabled
                : false;
        },
        async ensureLoaded({ force = false } = {}) {
            const cacheIsFresh = (
                this.loaded
                && Date.now() - this.lastLoadedAt < FEATURE_CACHE_TTL_MS
            );
            if (!force && cacheIsFresh) {
                return this.newsEnabled;
            }

            if (!featureRequest) {
                this.loading = true;
                featureRequest = getSiteFeaturesRequest()
                    .then((features) => {
                        this.newsEnabled = features?.news?.enabled === true;
                        this.loaded = true;
                        this.lastLoadedAt = Date.now();
                        return this.newsEnabled;
                    })
                    .catch(() => {
                        this.newsEnabled = false;
                        this.loaded = true;
                        this.lastLoadedAt = Date.now();
                        return false;
                    })
                    .finally(() => {
                        this.loading = false;
                        featureRequest = null;
                    });
            }

            return featureRequest;
        }
    }
});
